import React, {useEffect, useState} from "react";
import _ from "lodash";
import RichTextEditor from "./rich-text-editor";
import SelectPrompt from "../blog-post/select-prompt";
import CollectionMetaList from "../../../shopify/components/collections/collection-meta-list";
import ContentListWithActions from "./content-list-with-actions";
import {HTML_CONTENT_TYPE_LIST} from "../../constants/content.constant";

const AddEditRichText = ({
                             label = 'Add / Edit Text',
                             title = '',
                             url = '',
                             promptsList = undefined,
                             existingContent = '',
                             setContentLines,
                             contentLines,
                             contentTags = '',
                             toneOfVoice = 'Conversational',
                             prepareHtmlContent = undefined,
                             handleAddTextForContentLine = undefined,
                             selectedContentLine = undefined,
                             setSelectedContentLine = undefined,
                             inputTexts = undefined,
                             setInputTexts = undefined,
                             subTypeList = ['Title'],
                             isMetaLines = false,
                             buttonClass = 'button-gray',
                             isCollection = false,
                         }) => {
    const [showModal, setShowModal] = useState(false);
    const [currentContentLines, setCurrentContentLines] = useState(contentLines || []);
    const [sectionTitle, setSectionTitle] = useState(null);
    const [currentInputText, setCurrentInputText] = useState(null);
    const [showRichTextEditor, setShowRichTextEditor] = useState(false);

    /*useEffect(() => {
        prepareCurrentInputText();
    }, [showModal]);*/

    useEffect(() => {
        if (selectedContentLine) {
            setCurrentContentLines([]);
            let sectionText = '';

            if (selectedContentLine.text.includes(':')) {
                const splitText = selectedContentLine.text.split(':');
                sectionText = splitText[0];
            } else if (selectedContentLine.section) {
                sectionText = selectedContentLine.section;
            } else {
                sectionText = selectedContentLine.text;
            }

            setSectionTitle(sectionText);
            setShowModal(true);
            prepareCurrentInputText(sectionText);
        }

    }, [selectedContentLine]);

    const prepareCurrentInputText = (titleOrSection) => {
        setShowRichTextEditor(false);

        setTimeout(() => {
            const existingInputTexts = [...inputTexts];
            const existingCurrentInputTextMap = _.keyBy(existingInputTexts, 'title');

            if (existingCurrentInputTextMap.hasOwnProperty(titleOrSection)) {
                setCurrentInputText(existingCurrentInputTextMap[titleOrSection]);
            } else {
                setCurrentInputText({
                    title: titleOrSection,
                    text: '',
                });
            }

            setShowRichTextEditor(true);
        }, 1);
    }

    const handleConfirmAction = async () => {
        setShowModal(false);

        const existingContentLines: any = [...currentContentLines];

        let currentSection = '';
        _.forEach(existingContentLines, (contentLine, index) => {
            if (_.isEmpty(contentLine.newType)) {
                if (contentLine.key === 'OL-LI') {
                    contentLine.newType = 'ol';
                } else if (contentLine.key === 'UL-LI') {
                    contentLine.newType = 'ul';
                } else if (contentLine.key === 'H2') {
                    contentLine.newType = 'h2';
                    contentLine.isSection = true;
                } else if (contentLine.key === 'H3') {
                    contentLine.newType = 'h3';
                } else if (contentLine.key === 'H1') {
                    contentLine.newType = 'h1';
                } else if (contentLine.key === 'P') {
                    contentLine.newType = 'p';
                }
            }

            if (contentLine.isSection) {
                currentSection = contentLine.text;
            }

            if (sectionTitle) {
                contentLine.section = sectionTitle;
            }

            if (contentLine.text.includes(':') && contentLine.text.indexOf(':') !== contentLine.text.length - 1) {
                contentLine.containsColon = true;
            }

            if (isMetaLines) {
                prepareMetaType(contentLine);
            }
        });

        const existingInputTexts = [...inputTexts];
        const existingCurrentInputText = {...currentInputText};
        const existingCurrentInputTextMap = _.keyBy(existingInputTexts, 'title');
        existingCurrentInputTextMap[existingCurrentInputText.title] = existingCurrentInputText;
        setInputTexts(_.values(existingCurrentInputTextMap));

        emitAfterChanges(existingContentLines);
    }

    const emitAfterChanges = (existingContentLines) => {
        if (_.isEmpty(selectedContentLine)) {
            setContentLines(existingContentLines);
        } else if (handleAddTextForContentLine) {
            handleAddTextForContentLine(existingContentLines);
        }
    }

    const prepareMetaType = (contentLine) => {
        if (contentLine.text.indexOf('Tags') > -1) {
            contentLine.metaType = 'tags';
        } else if (contentLine.text.indexOf('Meta') > -1) {
            contentLine.metaType = 'meta';
        } else if (contentLine.text.indexOf('Excerpt') > -1) {
            contentLine.metaType = 'excerpt';
        }
    }

    const handleCancelAction = () => {
        if (selectedContentLine) {
            setSelectedContentLine(null);
        }

        setShowModal(false);
    }

    const handleOpenAddEditRichTextForTitle = () => {
        if (selectedContentLine) {
            setSelectedContentLine(null);
        }

        setShowModal(true);
        prepareCurrentInputText(title);
    }

    return (
        <>
            <button
                className={`${buttonClass} px-3 py-2`}
                onClick={handleOpenAddEditRichTextForTitle}>
                {label}
            </button>

            {showModal ? (
                <>
                    <div
                        className="justify-center items-center mt-8 flex overflow-x-hidden overflow-y-auto fixed inset-x-0 top-0 z-50 outline-none focus:outline-none">
                        <div className="relative w-3/4">
                            {/*content*/}
                            <div
                                className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-gray-100 outline-none focus:outline-none">
                                {/*header*/}
                                <div
                                    className="flex text-center justify-between p-5 border-b border-solid rounded-t">
                                    <h3 className="text-lg font-semibold">
                                        {label}
                                    </h3>
                                    <h3 className="ml-4 text-lg font-bold text-purple-500">
                                        {title}
                                        {sectionTitle && selectedContentLine &&
                                            <>
                                                <span className={'mx-1 text-black'}>|</span><span
                                                className={'text-gray-500'}>{sectionTitle}</span>
                                            </>
                                        }
                                    </h3>
                                    <div className={'w-1/4'}>
                                        <button
                                            className="ml-2 text-gray-500 font-bold border border-gray-500 h-10 rounded px-4 outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                            type="button"
                                            onClick={handleCancelAction}>
                                            Cancel
                                        </button>
                                        <button
                                            className="ml-2 bg-green-500 text-white active:bg-green-600 h-10 px-4 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                            type="button"
                                            onClick={handleConfirmAction}>
                                            Confirm Text
                                        </button>
                                    </div>
                                </div>
                                {/*body*/}
                                <div className="relative p-5 flex-auto">
                                    <div
                                        className={'h-96 overflow-y-scroll bg-gray-500 border border-gray-500 p-4 rounded'}>
                                        {promptsList && promptsList.length > 0 &&
                                            <>
                                                {!title && !selectedContentLine &&
                                                    <div className="mb-4">
                                                        <SelectPrompt
                                                            setContentText={setCurrentInputText}
                                                            contentTags={contentTags}
                                                            toneOfVoice={toneOfVoice}
                                                            subTypeList={subTypeList}
                                                            promptsList={promptsList}
                                                            url={url}/>
                                                    </div>
                                                }

                                                {title && !selectedContentLine &&
                                                    <div className="mb-4">
                                                        <SelectPrompt
                                                            setContentText={setCurrentInputText}
                                                            contentTags={contentTags}
                                                            toneOfVoice={toneOfVoice}
                                                            subTypeList={subTypeList}
                                                            promptsList={promptsList}
                                                            url={url}
                                                            title={title}/>
                                                    </div>
                                                }

                                                {selectedContentLine && sectionTitle &&
                                                    <div className="mb-4">
                                                        <SelectPrompt
                                                            setContentText={setCurrentInputText}
                                                            subTypeList={['Section']}
                                                            toneOfVoice={toneOfVoice}
                                                            promptsList={promptsList}
                                                            title={sectionTitle}/>
                                                    </div>
                                                }
                                            </>
                                        }
                                    </div>

                                    <div
                                        className="my-4 mx-2 py-4 add-edit-text-container text-left flex justify-start">
                                        {showRichTextEditor &&
                                            <div className={`mx-2 ${isCollection ? 'w-1/2' : 'w-full'}`}>
                                                <RichTextEditor
                                                    existingContent={currentInputText?.text}
                                                    currentInputText={currentInputText}
                                                    setCurrentInputText={setCurrentInputText}
                                                    setContentLines={setCurrentContentLines}/>
                                            </div>
                                        }

                                        {isCollection &&
                                            <div className={'mx-2 w-1/2'}>
                                                <CollectionMetaList
                                                    metaLines={currentContentLines}
                                                    handleCollectionDetailChange={() => {
                                                        emitAfterChanges(currentContentLines);
                                                    }}/>
                                            </div>
                                        }

                                        {/*{!isCollection &&
                                                <div
                                                    className={'border border-gray-500 bg-white p-4 mb-8 rounded-lg add-edit-text-container overflow-y-scroll'}>
                                                    <ContentListWithActions
                                                        elementTypeList={HTML_CONTENT_TYPE_LIST}
                                                        contentLines={currentContentLines}
                                                        handleContentDetailChange={() => {
                                                            emitAfterChanges(currentContentLines);
                                                        }}/>
                                                </div>
                                            }*/}
                                    </div>
                                </div>
                                {/*footer*/}
                                {/*<div
                                    className="flex items-center justify-end p-5 border-t border-solid border-blueGray-200 rounded-b">
                                    <button
                                        className="ml-2 text-gray-500 font-bold border border-gray-500 h-10 rounded px-4 outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                        type="button"
                                        onClick={handleCancelAction}>
                                        Cancel
                                    </button>
                                    <button
                                        className="ml-2 bg-green-500 text-white active:bg-green-600 h-10 rounded px-4 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                        type="button"
                                        onClick={handleConfirmAction}>
                                        Confirm Text
                                    </button>
                                </div>*/}
                            </div>
                        </div>
                    </div>
                    <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                </>
            ) : null}
        </>
    );
}

export default AddEditRichText;

function userEffect(arg0: () => void) {
    throw new Error("Function not implemented.");
}

